<div id="chart">
  <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [plotOptions]="chartOptions.plotOptions"
    [labels]="chartOptions.labels"></apx-chart>
</div>
